import React, { useContext } from 'react'
import classnames from 'classnames'

// Context
import { AppContext } from '../../../../../../contexts'

// Hooks
import { useFullListingData } from '../../../../../../hooks/listing'
import { useBuyerSettingsWithDefaults } from '../../../../../../hooks/buyerSettings'

// Styles
import baseStyles from '../base.module.scss'
import baseButtonStyles from '../../../../../../components/Button/Button.module.scss'
import styles from './RentalPotential.module.scss'

// Components
import {
  Text,
  Button,
  Panel,
  CircleIcon,
  PanelDivider,
  Checkbox,
} from '../../../../../../components'

// SVGs
import { Pencil } from '../../../../../../components/Svg'

// Helpers
import { formatToCurrency } from '../../../../../../helpers'

// Constants
import { INPUT_NAMES } from '../../../../../../constants/display'

const RentalPotential = () => {
  const { avgNightlyRental } = useFullListingData()
  const { rentableNights } = useBuyerSettingsWithDefaults()
  const {
    includeRental,
    setIncludeRental,
    setFocusFieldAndNavigateToSettings,
  } = useContext(AppContext)

  if (!avgNightlyRental) {
    return null
  }

  return (
    <Panel className={classnames(baseStyles.panel, styles.panel)}>
      <div className={styles.header}>
        <CircleIcon
          className={baseStyles.icon}
          backgroundColor='success'
          icon='greenMoneyBag'
        />
        <div className={styles.headerText}>
          <Text
            transform='uppercase'
            letterSpacing='large'
            size='s'
            color='green'
            weight='bold'
          >
            Airbnb Income
          </Text>
        </div>
      </div>

      <div className={styles.body}>
        <Text color='white'>
          Based on similar rentals nearby, you may be able to rent this home for
          <Text element='span' color='green' weight='semibold'>
            {' '}
            {formatToCurrency(avgNightlyRental)}/night{' '}
          </Text>
          for
          <Button
            editable
            className={baseButtonStyles.border}
            iconEnd={Pencil}
            onClick={() =>
              setFocusFieldAndNavigateToSettings(INPUT_NAMES.RENTABLE_NIGHTS)
            }
          >
            {rentableNights} {rentableNights === 1 ? 'night' : 'nights'}/mo
          </Button>
        </Text>
      </div>

      <div className={styles.results}>
        <Text
          className={styles.equal}
          element='div'
          weight='bold'
          color='heather'
          size='l'
        >
          =
        </Text>
        <Text
          className={styles.income}
          element='div'
          size='xxxl'
          color='eggShell'
          weight='light'
        >
          {formatToCurrency(rentableNights * avgNightlyRental)}
          <Text className={styles.perMonth} element='span' weight='bold'>
            {' '}
            / mo
          </Text>
        </Text>
      </div>
      <PanelDivider footer>
        <div className={styles.footer}>
          <Text size='s'>See how this can offset monthly expenses</Text>
          <Checkbox
            toggle
            checked={includeRental}
            onChange={e => setIncludeRental(e.target.checked)}
          />
        </div>
      </PanelDivider>
    </Panel>
  )
}

export default RentalPotential
